import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

// Colore condiviso fra Cassa e Agenda: fonte unica = /service-categories.
// Il colore è salvato come tripletta HSL (es. "271 70% 55%") per usarlo sia
// come tinta piena hsl(...) sia come sfondo con alpha hsl(... / a).

export const UNCATEGORIZED = "Da categorizzare";
const FALLBACK = "43 45% 54%"; // oro neutro

// Palette preset selezionabile nella gestione categorie (nome -> tripletta HSL).
export const CATEGORY_PALETTE = [
  { key: "Viola", hsl: "271 70% 55%" },
  { key: "Oro", hsl: "43 74% 49%" },
  { key: "Blu", hsl: "221 83% 55%" },
  { key: "Rosa", hsl: "330 78% 56%" },
  { key: "Verde", hsl: "142 60% 42%" },
  { key: "Arancione", hsl: "25 90% 52%" },
  { key: "Turchese", hsl: "174 72% 42%" },
  { key: "Rosso", hsl: "0 72% 55%" },
  { key: "Indaco", hsl: "244 52% 56%" },
  { key: "Smeraldo", hsl: "160 78% 38%" },
  { key: "Ambra", hsl: "38 92% 48%" },
  { key: "Grafite", hsl: "220 9% 46%" },
];

// Tinta deterministica per categorie non mappate (coerente ovunque).
const HASH_HUES = ["14 80% 52%", "173 58% 39%", "262 65% 58%", "0 72% 55%", "191 82% 40%", "128 55% 42%", "310 60% 52%"];
export function colorFor(colorByName, name) {
  if (name && colorByName && colorByName[name]) return colorByName[name];
  if (!name) return FALLBACK;
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return HASH_HUES[h % HASH_HUES.length];
}

export const solid = (triplet) => `hsl(${triplet})`;
export const tint = (triplet, a = 0.12) => `hsl(${triplet} / ${a})`;

// Hook: carica le categorie servizi e fornisce mappe pronte all'uso.
export function useServiceCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(() => {
    setLoading(true);
    return api.get("/service-categories")
      .then((r) => setCategories(Array.isArray(r.data) ? r.data : []))
      .catch(() => setCategories([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const colorByName = {};
  categories.forEach((c) => { colorByName[c.name] = c.color; });

  return { categories, colorByName, loading, reload };
}
